import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";
import { getModelLink } from "@/modules/model";

import { AssetTypeType } from "./AssetType.type";

const AssetTypesLinksList = ({ assetTypes }) => {
  const links = assetTypes?.map((assetType) => ({
    label: assetType.name,
    to: getModelLink("assettype", assetType),
  }));

  return <LinksList links={links} />;
};

AssetTypesLinksList.propTypes = {
  assetTypes: PropTypes.arrayOf(AssetTypeType),
};

export default AssetTypesLinksList;
